import { configureStore } from '@reduxjs/toolkit';

import { isDev, isLocal, isTest } from 'config';
import { rtkQueryError } from 'utils/fetchUtils/fetchUtils';
import { onSessionUpdated } from 'utils/sessionEvents';
import { authReducer, sessionUpdated } from './authState';
import { brandReducer } from './brandState/brandState';
import { diamApi } from './diamApi';
import { globalErrorReducer } from './globalErrorState';
import { groupReducer } from './groupState/groupState';
import { localizationReducer } from './localizationState';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    brand: brandReducer,
    group: groupReducer,
    globalError: globalErrorReducer,
    localization: localizationReducer,
    [diamApi.reducerPath]: diamApi.reducer
  },
  middleware: (getDefaultMiddleware) => {
    // Middlewares
    const middlewares = [diamApi.middleware];

    if (!isTest) {
      middlewares.push(rtkQueryError);
    }

    return getDefaultMiddleware().concat(middlewares);
  },
  devTools: isLocal || isDev
});

// Hook up session events to update store on token refresh
onSessionUpdated((session) => {
  store.dispatch(sessionUpdated(session));
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
